// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"3210":"c55f71ec0da19832","7237":"566e8de5a3dc39a3"}[chunkId] + ".css";
};